module.exports = __webpack_public_path__ + "img/stand-none.7daf9a96.png";